$(document).ready(function(){
  if($('.heading-section')){
    $('.heading-section .list').addClass('swiper-wrapper');
    $('.heading-section .list .item').addClass('swiper-slide');
    $('.heading-section .container').addClass('swiper-img');
    var swiper = new Swiper(".swiper-img", {
      allowTouchMove: true,
      pagination: true,
      breakpoints: {
        0: {
          slidesPerView: 2,
          spaceBetween: 14,
        },
        425: {
          slidesPerView: 3,
          spaceBetween: 14,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        900: {
          slidesPerView: 3,
          spaceBetween: 10,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        1440:{
          slidesPerView: 4.05,
          spaceBetween: 5,
        },
        1700: {
          slidesPerView: 5,
          spaceBetween: 10,
        },
      }
    });
  }
  if($('.contact-section')){
    $('.contact-section .slide-container').addClass('swiper-wrapper');
    $('.contact-section .slide-container .item').addClass('swiper-slide');
    $('.contact-section .contact-container').addClass('swiper-contact');
    var swiper = new Swiper(".swiper-contact", {
      slidesPerView: 4,
      spaceBetween: 10,
      allowTouchMove: false,
//       pagination: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          allowTouchMove: true,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 4,
          allowTouchMove: false,
          spaceBetween: 0,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' +  '</span>';
        },
      }
    });
  }
	
  
})

	function resizedw(){
    $('.this-product-section .item .content').matchHeight();
  }
  var doit;
  window.onresize = function(){
    clearTimeout(doit);
    doit = setTimeout(resizedw, 100);
  };

  $('.this-product-section .item .content').matchHeight();
